import { render } from "./FunctionArea.vue?vue&type=template&id=435875e6&scoped=true"
import script from "./FunctionArea.vue?vue&type=script&lang=ts"
export * from "./FunctionArea.vue?vue&type=script&lang=ts"

import "./FunctionArea.vue?vue&type=style&index=0&id=435875e6&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-435875e6"

export default script